import { MondayImportItemsPicker } from "../monday-import-items-picker/monday-import-items-picker";
import type { MondayBoardSelectorProps } from "./monday-board-selector.types";

export function MondayBoardSelector({
  workspaces,
  selectedWorkspace,
  workspacesLoading,
  workspacesInitialLoading,
  workspacePickerTitle = "Workspace",
  loadMoreWorkspaces,
  setSelectedWorkspace,
  boards,
  selectedBoard,
  boardsLoading,
  boardsInitialLoading,
  boardPickerTitle = "Board",
  disabledBoardTooltip,
  pickerStyle,
  pickerWidth,
  setSelectedBoard,
  loadMoreBoards,
  isBoardDisabled,
  useFloatingDropdown = false,
  onSearch,
}: MondayBoardSelectorProps) {
  return (
    <>
      <MondayImportItemsPicker
        type="workspace"
        options={workspaces}
        selectedOption={selectedWorkspace}
        setSelectedOption={setSelectedWorkspace}
        fetchMore={loadMoreWorkspaces}
        loadingMore={workspacesLoading}
        isLoading={workspacesInitialLoading}
        pickerTitle={workspacePickerTitle}
        pickerStyle={pickerStyle}
        pickerWidth={pickerWidth}
        useFloatingDropdown={useFloatingDropdown}
        trackingEventName="cim_workspace_selected"
      />

      <MondayImportItemsPicker
        type="board"
        options={boards}
        selectedOption={selectedBoard}
        setSelectedOption={setSelectedBoard}
        showIcon={false}
        loadingMore={boardsLoading}
        isLoading={boardsInitialLoading}
        fetchMore={loadMoreBoards}
        isOptionDisabled={isBoardDisabled}
        disabledTooltip={disabledBoardTooltip}
        pickerTitle={boardPickerTitle}
        pickerStyle={pickerStyle}
        pickerWidth={pickerWidth}
        useFloatingDropdown={useFloatingDropdown}
        onSearch={onSearch}
        trackingEventName="cim_board_selected"
      />
    </>
  );
}
